import { render, staticRenderFns } from "./proy-corporacion.vue?vue&type=template&id=47f7c2d6"
import script from "./proy-corporacion.vue?vue&type=script&lang=js"
export * from "./proy-corporacion.vue?vue&type=script&lang=js"
import style0 from "./proy-corporacion.vue?vue&type=style&index=0&id=47f7c2d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports